module.exports = __webpack_public_path__ + "static/media/pencil.1f3de3c6.svg";